<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">
      <section class="">
        <div class="container">
          <div class="row list">
            <div class="col-lg-12 col-md-12">
              <button @click="printMe" class="btn btn-outline-info my-2">
                Print
              </button>
            </div>
          </div>

          <div class="row" id="printDiv">
            <div class="col-md-12">
              <div class="card">
                <div class="card-header">
                  <div class="row mt-6">
                    <div class="col-md-12">
                      <div class="d-flex align-items-center justify-content-center">
                        <img src="/assets/img/ohis_logo.png" alt="OHIS Logo" class="mr-3"
                          style="width: 56px; height: 56px; object-fit: contain" />
                        <div class="h3 text-center mb-0">
                          <strong>
                            <p class="h5 mb-1">
                              Osun Health Insurance Scheme (O'HIS)
                            </p>
                          </strong>
                          <strong>
                            <p class="text-center mb-0">Enrollment Slip</p>
                          </strong>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="table-responsive">
                        <table class="table align-td-middle table-borderless text-left">
                          <tbody>
                            <tr>
                              <td>
                                <img :src="`${client.user.image_url}`" class="rounded"
                                  style="width: 10rem; height: 10rem;"
                                  onerror="this.onerror=null; this.src='/ohis_logo.png'" />
                              </td>
                              <td></td>
                              <td>
                                <p class="">
                                  <b>Generated On: </b>
                                  <span> {{ current_date }} </span>
                                </p>
                                <qrcode-vue :value="`https://app.oshia.ng/verify-user/${$route.params.id}`" :size="80"
                                  :level="'H'" render-as="svg"></qrcode-vue>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <b>Full Name:</b> {{ client.user.full_name }}
                              </td>
                              <td>
                                <b>O'HIS ID:</b>
                                {{ client.user.id_card_number }}
                              </td>
                              <td>
                                <b>Health Provider:</b>
                                <span v-if="client.user.userprovider != null">
                                  {{ client.user.userprovider.agency_name }}
                                </span>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <b>Establishment:</b>
                                {{ client.user.place_of_work }}
                              </td>
                              <td><b>Sector: </b> {{ client.user.sector }}</td>
                              <td>
                                <b>Date Enrolled:</b>
                                {{
                                client.user.created_at
                                | moment("dddd, MMMM Do YYYY")
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td><b>NIN:</b> {{ client.user.nimc_number }}</td>
                              <td><b>Gender:</b> {{ client.user.gender }}</td>
                              <td>
                                <b>Phone Number:</b>
                                {{ client.user.phone_number }}
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <b>LGA/Ward:</b>
                                <span v-if="client.user.localgovt != null">{{
                                  client.user.localgovt.local_name
                                  }}</span>
                                /

                                <span v-if="client.user.ward != null">
                                  {{ client.user.ward.ward_name }}
                                </span>
                              </td>
                              <td>
                                <b>Date of Birth:</b>
                                {{ client.user.dob | moment("D/M/YYYY") }}
                              </td>
                              <td><b>Email:</b>{{ client.user.email }}</td>
                            </tr>

                            <tr>
                              <td>
                                <b>Expiry Date:</b>
                                {{ client.user.expiry_date }}
                              </td>
                              <td>
                                <b>Marital Status:</b>
                                {{ client.user.marital_status }}
                              </td>
                              <td>
                                <b>Employment:</b>
                                {{ client.user.place_of_work }}
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <b>Employment ID:</b>
                                {{ client.user.salary_number }}
                              </td>
                              <td>
                                <b>Vulnrable Group:</b>
                                {{ client.user.category_of_vulnerable_group }}
                              </td>
                              <td>
                                <b>Address:</b> {{ client.user.address1 }}
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <b>Blood Group:</b> {{ client.user.blood }}
                              </td>
                              <td>
                                <b>HMO :</b>
                                <span v-if="client.tpa != null">
                                  {{ client.tpa.organization_name }}
                                </span>
                              </td>
                              <td>
                                <b>Date of Enrollment :</b>
                                <span>
                                  {{ client.created_at }}
                                </span>

                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-12">
              <div class="card m-b-30">
                <div class="card-body">
                  <div class="form-group">
                    <b class="h5">Enrollee Dependents</b>
                  </div>

                  <hr />

                  <div class="col-md-12 m-b-30">
                    <div class="table-responsive">
                      <table class="table align-td-middle table-card">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Avatar</th>
                            <th>Name</th>
                            <th>ID Number</th>
                            <th>DOB</th>
                            <th>Gender</th>
                            <th>Blood Group</th>
                            <th>Relationship</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(dependent, index) in dependents" v-bind:key="dependent.id">
                            <td>
                              {{ index + 1 }}
                            </td>
                            <td>
                              <vue-initials-img :name="
                                  dependent.firstname + ' ' + dependent.lastname
                                " class="img-thumbnail" size="25" v-if="dependent.image == null" />

                              <div class="avatar avatar-md" v-if="dependent.image != null">
                                <img :src="`${dependent.image_url}`" class="avatar-img avatar-lg rounded"
                                  onerror="this.onerror=null; this.src='/assets/img/claimify_logo.png'" alt="" />
                              </div>
                            </td>
                            <td>
                              <router-link :to="{ path: '/provider-' + dependent.id }">
                                <span class="font-bold">
                                  {{ dependent.firstname }}
                                  {{ dependent.middlename }}
                                  {{ dependent.lastname }}
                                </span>
                              </router-link>
                            </td>
                            <td>
                              {{ dependent.id_card_number }}
                            </td>
                            <td>
                              {{ dependent.dob }}
                            </td>
                            <td>{{ dependent.gender }}</td>
                            <td>{{ dependent.blood }}</td>
                            <td>{{ dependent.relationShipType }}</td>
                          </tr>
                          <!-- <tr>
                            <td colspan="4">
                              <b> Prepared By:</b> {{ user.full_name }}
                            </td>

                            <td colspan="4" class="text-right">
                              <p>
                                <b> Authorized By:</b>
                                .....................................
                              </p>
                            </td>
                          </tr> -->
                        </tbody>
                      </table>
                    </div>
                  </div>


                  <!-- <div class="row col-md-12">
                    <div class="col-md-8">
                      <p><b> Prepared By:</b> {{ user.full_name }}</p>
                    </div>

                    <div class="col-md-4">
                      <p>
                        <b> Authorized By:</b>
                        .....................................
                      </p>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>

            <!-- <EnrolleeCardBack :verify-url="`https://rivchpp.web.app/verify-user/${$route.params.id}`" /> -->
          </div>
        </div>

        <div class="vld-parent">
          <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
        </div>
      </section>
    </main>
  </section>
</template>

<script>
  import Navbar from "@/views/Navbar.vue";
  // Import component
  import Loading from "vue-loading-overlay";
  // Import stylesheet
  import "vue-loading-overlay/dist/vue-loading.css";
  // Init plugin
  import QRCodeVue from "qrcode.vue";
  // import EnrolleeCardBack from "@/views/clients/components/EnrolleeCardBack.vue";
  let agency = JSON.parse(localStorage.getItem("agency"));
  import moment from "moment";
  moment().format();

  export default {
    components: {
      Navbar,
      Loading,
      qrcodeVue: QRCodeVue,
      // EnrolleeCardBack,
    },
    data() {
      return {
        agency: agency,
        activities: "",
        current_date: moment().subtract(0, "days").format("YYYY-MM-DD"),
        user: null,
        trx_image: false,
        auth_user: "",
        client: { user: "full_name", transactions: [] },
        trx_doc: null,
        notes: "",
        dependents: "",
        medications: "",
        healthFacility: "",
        signature: "",
        enrolled_by: "",
        singleward: "",
        singlelga: "",
        edit: false,
        isLoading: false,
        fullPage: true,
        transactionID: "",
        agency_id: "",
        imagefile: "",
        image: "",
        paymentProofFile: "",
        paymentProofImage: "",
        output: "",
        pictureShower: true,
      };
    },
    mounted() {
      this.print();
    },
    beforeMount() {
      this.user = JSON.parse(localStorage.getItem("user"));

    },

    computed: {},

    methods: {
      async print() {
        const el = this.$refs.printNow;

        const options = {
          type: "dataURL",
        };
        this.output = await this.$html2canvas(el, options);
      },

      printMe() {
        var printContents = document.getElementById("printDiv").innerHTML;
        var originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
      },

      fetchUser() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(`/api/v1/user-no-auth/${this.$route.params.id}`)
          .then((response) => {
            this.client = response.data;
            this.dependents = response.data.dependents;
          })
          .catch((error) => {
            console.error(error);
          });
      },
    },
    created() {
      this.fetchUser();
    },
  };
</script>
<style scoped>
  /* @media print {
  @page {
    margin: 0;
  }
} */
</style>